import styled from 'styled-components';

import { layout } from 'config/theme';
export const CheckboxWrapper = styled.div`
  border: 1px solid #cacaca;
  border-radius: ${layout.borderRadius.m};
  padding: 10px;
  height: 320px;
  overflow-y: scroll;
`;
